<template>
  <div class="ActionButton">
    <b-button variant="outline-grey" class="action-button" @click="$emit('click')" v-b-tooltip.body.window.hover.bottom.html :title="tooltip" :disabled="disabled">
        <icon-svg size="20" :icon="icon" :bold="bold" :light="light"></icon-svg>
        <span class="d-none d-xl-inline btntext">{{text}} <b-spinner v-if="save" type="grow" small></b-spinner></span>
    </b-button>
  </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import IconSvg from '@/components/shared/IconSvg'
export default {
  name: 'ActionButton',
  components:{
      IconSvg
  },
  props:{
      icon:String,
      text:String,
      bold:Boolean,
      light:Boolean,
      tooltip: String,
      disabled: Boolean,
      save: Boolean
  },
  data () {
    return {

    }
  },
  mounted () {

  },
  computed:{
      iconVariant(){
          if(this.bold){
              return 'bold';
          } else if(this.light){
              return 'light';
          } else {
              return 'regular';
          }
      }
    }
}
</script>

<style  lang="scss">
//@import './../../scss/_theme.scss';

    .ActionButton{
        margin-left: 3px;
            margin-top: 3px;
            margin-bottom: 3px;
        .btn {
            padding: 0.35rem 0.35rem;
        
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/ActionButton.vue